import { usePatients } from "@repo/data-store";
import { CommandPalette } from "@/app/command-palette/command-palette";
import { useCommandContext } from "@/app/command-palette/use-command-context";
import { useCommandHotkeys } from "@/app/command-palette/use-command-hotkeys";
import { OverlayHost } from "@/app/overlays";
import { ColleagueCallListener, ConferencingHost } from "@/features/conferencing";

/**
 * The command palette, the overlay stack, and the call. Both shells mount this
 * once, which is what keeps a single hotkey registration live and gives every
 * `openOverlay` call somewhere to render.
 *
 * `ConferencingHost` sits BESIDE `OverlayHost`, not in the overlay registry. A
 * call outlives the route that started it and holds a live session; the
 * registry's props are plain data and its entries are a stack a later overlay
 * can dismiss. Mounting it here rather than in each shell means it inherits the
 * same single-instance short-circuit `__root.tsx` already applies to this
 * component — two live sessions would fight over the microphone.
 *
 * `ColleagueCallListener` is mounted for the same single-instance reason and
 * renders nothing. It holds the one subscription that tells this clinician
 * somebody is ringing them; two of it would show every ring twice.
 */
export function GlobalOverlays() {
  const commandCtx = useCommandContext();
  useCommandHotkeys(commandCtx);
  const { patients } = usePatients();

  return (
    <>
      <CommandPalette patients={patients} commandCtx={commandCtx} />
      <OverlayHost />
      <ConferencingHost />
      <ColleagueCallListener />
    </>
  );
}
